import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table'
import useToken from '../../App/useToken';
import './Dashboard.css'

export default function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);
  
  

  return(
    <div className="course-list">
      Dashboard
      {isLoading && <div clalssname="container">
        <a 
          className="btn btn-outline-success btn-sm btn-creat-course" 
          href="/course/create"
        >
          เพิ่มหลักสูตร
        </a>
          Dashboard
      </div>}
    </div>
  )
}
